// Dynamic backend URL - uses current origin so deployments work
// without needing to manually update .env for each environment
export const BACKEND_URL = window.location.origin;

// CSRF double-submit token (cookie set by backend middleware, mirrored into header)
export const getCsrfToken = () => {
  const row = document.cookie.split('; ').find((r) => r.startsWith('csrf_token='));
  return row ? decodeURIComponent(row.split('=').slice(1).join('=')) : '';
};
